/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AreaTypeKey {
  ANNOTATION_BOUNDARY = "ANNOTATION_BOUNDARY",
  PERMIT_BOUNDARY = "PERMIT_BOUNDARY",
}

export enum DocumentRequirementKey {
  NONE = "NONE",
  REQUEST_AND_SUBMISSION = "REQUEST_AND_SUBMISSION",
  SUBMISSION = "SUBMISSION",
}

export enum GeoJSONGeometryType {
  GeometryCollection = "GeometryCollection",
  LineString = "LineString",
  MultiLineString = "MultiLineString",
  MultiPoint = "MultiPoint",
  MultiPolygon = "MultiPolygon",
  Point = "Point",
  Polygon = "Polygon",
}

export enum LicenceType {
  STANDARD = "STANDARD",
  VIEWER = "VIEWER",
}

export enum MetricTrendKey {
  DOWN = "DOWN",
  FLAT = "FLAT",
  UP = "UP",
}

export enum PermitToDigSignatureType {
  COMPLETION = "COMPLETION",
  DOCUMENT = "DOCUMENT",
  GANG_MEMBER = "GANG_MEMBER",
  PERMIT_AUTHORIZATION = "PERMIT_AUTHORIZATION",
  REQUEST = "REQUEST",
  SUBMISSION = "SUBMISSION",
}

export enum PermitToDigTrigger {
  APPROVE_REQUEST = "APPROVE_REQUEST",
  CANCEL = "CANCEL",
  COMPLETE = "COMPLETE",
  CREATE = "CREATE",
  CREATE_REQUEST = "CREATE_REQUEST",
  EXPIRE = "EXPIRE",
  EXTEND = "EXTEND",
  ISSUE = "ISSUE",
  REJECT_REQUEST = "REJECT_REQUEST",
  REPORT_PROBLEM = "REPORT_PROBLEM",
  REQUEST = "REQUEST",
  SAVE = "SAVE",
  SUBMIT = "SUBMIT",
  UNDO_CANCELLATION = "UNDO_CANCELLATION",
  WORK_COMPLETED = "WORK_COMPLETED",
}

export enum SitePhotoTypeKey {
  ISSUE = "ISSUE",
  PREPARATION = "PREPARATION",
  WORK_PROGRESS = "WORK_PROGRESS",
}

export enum StateKey {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  EXPIRED = "EXPIRED",
  IN_PROGRESS = "IN_PROGRESS",
  ISSUED = "ISSUED",
  READY_TO_ISSUE = "READY_TO_ISSUE",
  REJECTED = "REJECTED",
  REQUESTED = "REQUESTED",
  REQUEST_IN_PROGRESS = "REQUEST_IN_PROGRESS",
}

export interface AreaInput {
  polygon?: GeoJSONPolygonInput | null;
  typeKey: AreaTypeKey;
  comments?: string | null;
}

export interface BuriedServicesInductionInput {
  date?: any | null;
  number?: string | null;
  expiresOn?: any | null;
}

export interface CalibrationCertificateInput {
  catSerialNumber?: string | null;
  catCalibrationDate?: any | null;
  catCalibrationDueDate?: any | null;
  gennySerialNumber?: string | null;
  gennyCalibrationDate?: any | null;
  gennyCalibrationDueDate?: any | null;
}

export interface CompanyInductionInput {
  date?: any | null;
  number?: string | null;
}

export interface DocumentTypeSettingsInput {
  declaration?: string | null;
  requirementKey: DocumentRequirementKey;
}

export interface EmergencyContactInput {
  name?: string | null;
  phoneNumber?: string | null;
}

export interface EsriConfigInput {
  webMapItemId?: string | null;
  integrationTypeId?: string | null;
}

export interface FileMetaDataInput {
  id?: string | null;
  fileName?: string | null;
  contentType?: string | null;
}

export interface GeoJSONPolygonInput {
  type?: GeoJSONGeometryType | null;
  coordinates?: ((any | null)[] | null)[] | null;
  crs?: number | null;
}

export interface OrgUserFileInput {
  title: string;
  expiryDate?: any | null;
  fileMetaData?: FileMetaDataInput | null;
}

export interface PermitAssignmentInput {
  orgRoleId?: string | null;
  orgUserId?: string | null;
}

export interface PermitDataInput {
  comments?: string | null;
  contractor?: string | null;
  subContractor?: string | null;
  locationOfWork?: string | null;
  worksDescription?: string | null;
  from: any;
  to: any;
  hoursFrom: any;
  hoursTo: any;
  endsNextDay: boolean;
  noAffectedServices: boolean;
  affectedServices?: (string | null)[] | null;
}

export interface PermitFieldValueInput {
  fieldKey?: string | null;
  stringValue?: string | null;
  booleanValue?: boolean | null;
  numberValue?: any | null;
  dateValue?: any | null;
}

export interface PermitMetricQueryInput {
  scope: PermitMetricScopeInput;
  level?: string | null;
  dimension?: string | null;
}

export interface PermitMetricScopeInput {
  organizationId: string;
  projectIds?: (string | null)[] | null;
  registerIds?: (string | null)[] | null;
  teamMemberIds?: (string | null)[] | null;
  permitTypeIds?: (string | null)[] | null;
  stateKeys?: (string | null)[] | null;
  dateFrom?: any | null;
  dateTo?: any | null;
}

export interface PermitRoleSettingsInput {
  isPermitAssignee: boolean;
  mandatoryOnSubmission: boolean;
  shouldAuthorizePermit: boolean;
  authorizationDeclaration?: string | null;
}

export interface SitePhotoInput {
  fileMetaData?: FileMetaDataInput | null;
  comments?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
